export enum ComparaisonMode {
  LOT,
  ITEM,
  MATERIAL,
}
